import type { TrainingCompletionSync } from '../../../shared/domain/training/types.no-deps'
import type { ClientLogger } from '../../../shared/lib/ClientLogger.no-deps'
import { IDB_syncParamsTrainingCompletions, IDB_trainingCompletions } from '../IDB/IDB.dexie'
import { Serv_clientWithLogger } from '../Serv/Serv.client'
import { type Sync_Params, Sync_standardSync } from '../Sync/Sync.standardSync'

interface Sync_Response {
    syncTime: Date
    teams: number[]
    trainingCompletions: TrainingCompletionSync[]
}

function sync(logger: ClientLogger, params: Sync_Params): Promise<Sync_Response> {
    return Serv_clientWithLogger(logger).syncTrainingCompletions({ lastSyncTime: params.lastSyncTime })
}

async function write(logger: ClientLogger, response: Sync_Response): Promise<void> {
    if (response.trainingCompletions.length > 0) {
        await IDB_trainingCompletions().bulkPut(response.trainingCompletions)
        logger.log(`Saved ${response.trainingCompletions.length} training completions`)
    }
}

export async function Training_SyncCompletions(logger: ClientLogger) {
    logger.log('Syncing training recommendations')
    await Sync_standardSync({
        params: IDB_syncParamsTrainingCompletions(),
        sync: (params) => sync(logger, params),
        write: (response: Sync_Response) => write(logger, response),
        clear: () => IDB_trainingCompletions().clear(),
    })
}
